import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { ApiLogsTable } from '@/features/logs-management/api-logs/table';
import { useApiLogs } from '@/features/logs-management/hooks/useApiLogs';
import { logQueries } from '@/services/logsManagement/logsManagement.queries';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['code', 'category', 'createdDate', 'message']),
  desc: z.boolean(),
});

const apiLogsSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  page: z.coerce.number().positive().catch(1),
});

export const Route = createFileRoute('/(app)/logs-management/api-logs/')({
  loader: async ({ context: ctx }) => {
    const queryOptions = logQueries.api;
    const actualQueryFn = queryOptions.queryFn(ctx.client);
    const apiLogs = await ctx.queryClient.ensureQueryData({
      ...queryOptions,
      queryFn: actualQueryFn,
    });
    return {
      crumb: <CrumbTitle title="Api Logs" />,
      title: 'Api Logs',
      apiLogs,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => apiLogsSchema.parse(search),
});

function RouteComponent() {
  const { apiLogs } = useApiLogs();
  return <ApiLogsTable data={apiLogs} />;
}
